import React, { useState } from 'react';
import { ApButtonMain, ApLoaderDefault } from '@alixpartners/ui-components';
import download from 'downloadjs';
import {
  Info,
  Section,
  Header,
  RulesList,
  AgreementText,
  Container,
} from './DownloadFile.styles';
import { ApiContext } from 'context/ApiContext';
import { PERMISSIONS } from 'utils/constants';
import { RouteComponentProps } from 'react-router-dom';
import { downloadSpendFile } from 'utils/api';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';

interface IDownloadProps extends RouteComponentProps<any, any, any> {
  permissions: string[];
  fetchAuthorizationToken: any;
}

export const Download = (props: IDownloadProps) => {
  const { fetchAuthorizationToken, match, permissions } = props;
  const [isDownloading, setIsDownloading] = useState(false);
  const { fileName } = match.params;

  const canDownload = permissions.includes(PERMISSIONS.SPEND_ANALYSIS_READ);

  return (
    <Container>
      <Header>Private and confidential!</Header>
      <RulesList>
        <div>To download file you must:</div>
        <ul>
          <li>Secure and protect the data</li>
          <li>Only share this data with authorized parties</li>
          <li>Delete it from your local drives after it is no longer useful</li>
        </ul>
      </RulesList>
      <AgreementText>
        By clicking “Download File” you acknowledge and agree to fulfil your
        obligations listed above.
      </AgreementText>
      {canDownload ? (
        <Section>
          {isDownloading ? (
            <ApLoaderDefault />
          ) : (
            <ApButtonMain
              onClick={() => {
                setIsDownloading(true);
                fetchAuthorizationToken().then((token: string) => {
                  downloadSpendFile(fileName).then(async (url) => {
                    const response = await fetch(url, {
                      method: 'GET',
                    });
                    const file = await response.blob();
                    download(file, fileName);
                    setIsDownloading(false);
                  });
                });
              }}
            >
              Download File
            </ApButtonMain>
          )}
        </Section>
      ) : (
        <Section>
          <Info>You don't have permission to download this file</Info>
        </Section>
      )}
    </Container>
  );
};

export const DownloadFile = (props: any) => (
  <ApAuthenticationContextConsumer>
    {({ fetchAuthorizationToken }) => (
      <ApiContext.Consumer>
        {({ permissions }) => (
          <Download
            {...props}
            permissions={permissions}
            fetchAuthorizationToken={fetchAuthorizationToken}
          />
        )}
      </ApiContext.Consumer>
    )}
  </ApAuthenticationContextConsumer>
);
